/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { UserPortofolioDetailRequestInterface } from 'app/interfaces/lender/UserPortofolioDetailInterface';
import {
	getUserPortofolioDetailAction,
	getUserPortofolioListAction,
	IUserPortofolioDetailInterface,
	IUserPortofolioParamsRequest,
	IUserPortofolioParamsResponse,
	setUserPortofolioDetailAction,
	setUserPortofolioListAction,
} from '../actions/UserPortofolioAction';
import endpoints from '../../../constants/endpoints';
import apiRequest from '../api/api.request';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';

function* fetchUserPortofolioList({
	payload,
}: {
	payload: IUserPortofolioParamsRequest;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.USER_PORTOFOLIO_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			"X-Authenticated-Userid": `${JSON.parse(auth).userId}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const result = {
			userPortofolioList: data,
			pagination,
		};
		yield put(setUserPortofolioListAction(result));
		return payload;
	} catch (err) {
		return err;
	}
}

function setUserPortofolioListSaga({
	payload,
}: {
	payload: IUserPortofolioParamsResponse;
}): IUserPortofolioParamsResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

function* fetchUserPortofolioDetail({
	payload,
}: {
	payload: UserPortofolioDetailRequestInterface;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.USER_PORTOFOLIO_DETAIL,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const result = {
			detailList: data,
			borrowerId: payload.borrowerId,
			pagination,
		};
		yield put(setUserPortofolioDetailAction(result));
		return payload;
	} catch (err) {
		return err;
	}
}

function setUserPortofolioDetailSaga({
	payload,
}: {
	payload: IUserPortofolioDetailInterface;
}): IUserPortofolioDetailInterface {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

export default function* userPortofolioSaga(): Generator {
	yield takeLatest(getUserPortofolioListAction, fetchUserPortofolioList);
	yield takeLatest(setUserPortofolioListAction, setUserPortofolioListSaga);
	yield takeLatest(getUserPortofolioDetailAction, fetchUserPortofolioDetail);
	yield takeLatest(
		setUserPortofolioDetailAction,
		setUserPortofolioDetailSaga
	);
}
